import React, { Component } from 'react'
import './App.css'
import Routes from './routes'
import { Menu, Image, Icon, Dropdown, Confirm } from 'semantic-ui-react'
import { NavLink, withRouter } from 'react-router-dom'
import Logo from './CORTEX.DA@3x.png'
import Guid from 'guid'
import AuthUser from './libs/AuthUser'
import { FEATURE_NAME, QUEUES } from './libs/Constants'
import Cache from './libs/Cache'
import { AuthContext } from './AuthContext'
import { FlagsProvider } from 'flagged'
import { featureFlagApi } from './api/featureFlag'
import { hasFeature } from './libs/hasFeature'
class App extends Component {

	constructor(props) {
		super(props)
		this.state = {
			userToken: null,
			username: null,
			isAuthenticated: false,
			alertOpen: false,
			alertMessage: '',
			clientId: this.getClientId(),
			admin: false,
			users: [],
			featureFlags: [],
			dropDownQueues: QUEUES
		}

		this.handleLogout = this.handleLogout.bind(this)
		this.handleProfile = this.handleProfile.bind(this)
		this.handleQueueChange = this.handleQueueChange.bind(this)
		this.AuthUser = new AuthUser(this.handleTokenChanged)
	}

	getClientId = () => 'web-client:' + Guid.raw()

	async componentDidMount() {
		if (this.AuthUser.username) {
			const userToken = await this.AuthUser.get_id_token()
			const userInfo = await this.AuthUser.get_user_info()

			this.setState({
				userToken: userToken,
				username: userInfo.username,
				admin: userInfo.admin
			})
		}

		await this.setFeatureFlags();
	}

	handleProfile = () => {
		this.props.history.push('/profile')
	}

	handleQueueChange = (event, data) => {
		this.props.history.push('/queue/' + data.value)
	}

	handleLogout = async (event) => {
		const cache = new Cache(AuthUser)
		cache.clear()

		this.AuthUser.signout()
		this.props.history.push('/')
	}

	handleLogoutIdle = async () => {
	}

	handleTokenChanged = async () => {
		const userToken = await this.AuthUser.get_id_token()
    const username = this.AuthUser.username
    const admin = await this.AuthUser.is_admin()

		this.setState({
			userToken: userToken,
      username: username,
      admin: admin
		})

		await this.setFeatureFlags()
	}

	setFeatureFlags = async () => {
		try {
			const { userToken } = this.state;
			const features = await featureFlagApi.getFeatures(userToken);
			let activeFeatures = [];

			if (features) {
				features.forEach((feature) => {
					if (feature.is_enabled) {
						activeFeatures.push(feature.feature_name);
					}
				})
			}

			this.setState({ featureFlags: activeFeatures });
			this.updateQueues();

		} catch (ex) {
			console.error('Error getting feature flags.', ex);
		}
	}

	updateQueues = () => {
		const {featureFlags } = this.state;
		const hasClosedQueueFilterFeature = hasFeature(featureFlags, FEATURE_NAME.CLOSED_QUEUE_FILTER)
		let dropDownList = [];

		if (hasClosedQueueFilterFeature) {
			dropDownList = QUEUES
		} else {
			dropDownList = QUEUES.filter((queue) => queue.NAME !== 'CLOSED');
		}

		this.setState({ dropDownQueues: dropDownList })
	}

	render() {
		const { dropDownQueues } = this.state;
		return (
			<FlagsProvider features={this.state.featureFlags}>
				<div className='App container'>
					<div className='TopMenu'>

						<Menu id='user-menu' className='borderless' inverted attached style={{ backgroundColor: '#2B3990' }}>
							<Menu.Item>
								<NavLink to='/'><Image style={{ display: 'inline', width: '125px' }} src={Logo} /></NavLink>
							</Menu.Item>

							{this.state.userToken
								?
								<Menu.Menu position='right'>
									<Menu.Item id='user-menu-dashboard'>
										<NavLink to='/dashboard'><Icon name='dashboard' />DASHBOARD</NavLink>
									</Menu.Item>
									<Menu.Item id='user-menu-user-dashboard'>
										<NavLink to='/user-dashboard'><Icon name='user circle' />USER DASHBOARD</NavLink>
									</Menu.Item>
									<Menu.Item id='user-menu-queue'>
										<Dropdown trigger={<span><Icon name='tasks' />QUEUE</span>}>
											<Dropdown.Menu>
												{dropDownQueues.map((queue) => (
													<Dropdown.Item key={queue.ID} as={NavLink} to={"/queue/" + queue.ID}>
														{queue.NAME}
													</Dropdown.Item>
												))}
											</Dropdown.Menu>
										</Dropdown>

									</Menu.Item>
									<Menu.Item id='user-menu-reports'>
										<Dropdown fluid trigger={<span><Icon name='area chart' />REPORTS</span>}>
											<Dropdown.Menu>
												<Dropdown.Item as={NavLink} to='/log'>
													Tracking Log
												</Dropdown.Item>

												{this.state.admin &&
													<Dropdown.Item as={NavLink} to='/executive'>
														Executive Dashboard
													</Dropdown.Item>
												}

												{this.state.admin &&
													<Dropdown.Item as={NavLink} to='/productivity'>
														Productivity
													</Dropdown.Item>
												}
											</Dropdown.Menu>
										</Dropdown>
									</Menu.Item>
									<Menu.Item id='user-menu-teams'>
										<NavLink to='/teams'><Icon name='users' />TEAMS</NavLink>
									</Menu.Item>
									<Menu.Item id='user-menu-search'>
										<NavLink to='/search'><Icon name='search' />SEARCH</NavLink>
									</Menu.Item>
									<Menu.Item id='user-menu-account'>
										<Dropdown item icon='user' text={this.state.username}>
											<Dropdown.Menu>
												<Dropdown.Item id='user-menu-account__sign-out' onClick={this.handleLogout}>
													SIGN OUT
												</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									</Menu.Item>

								</Menu.Menu>
								: <div></div>
							}

						</Menu>
						<div className='ui fluid main container'>
							<Confirm open={this.state.alertOpen} content={this.state.alertMessage}
								onConfirm={this.handleAlertConfirm} onCancel={this.handleAlertCancel}
								closeOnDimmerClick={false}
							/>
							<AuthContext.Provider value={{ userName: this.state.username, AuthUser: this.AuthUser }}>
								<Routes />
							</AuthContext.Provider>
						</div>
					</div>
				</div>
			</FlagsProvider>
		)
	}
}
///

export default withRouter(App)
